<mat-toolbar class="mc-toolbar-large" [ngClass]="{ 'mc-solo-file-text-editor-status-bar-visible': exceedsMaxSize }" color="warn">
  <ng-container *ngIf="exceedsMaxSize">
    <mat-icon fontSet="project-titan" fontIcon="icon-alert" class="mc-centered-text-icon"></mat-icon>
    <span>Document is too large to save and load in Code tab. Current size: {{ size | mcFileSize : 2 }}. Max size: {{ maxSize | mcFileSize : 0 }}.</span>
  </ng-container>
</mat-toolbar>